function errorhandler(error) {
  var accessDenied = error.toString().indexOf("401");
  if (accessDenied !== -1) {
    console.log("ACCESS DENIED");
    return (window.location.href = "/admin/login");
  }
}

export default errorhandler;
